import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';
import { num_word } from 'vpl.tas';


export const CatalogInnerSections = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    methods: {
        num_word: num_word,
        showMore(event){
            let btn = $(event.target),
                list = btn.parent().find('.js-catalog-links-list');

            if (!btn.hasClass('is-show')) {
                btn.addClass('is-show');
                btn.text('Свернуть');
                list.addClass('is-show');
            } else {
                btn.removeClass('is-show');
                btn.text('Показать ещё');
                list.removeClass('is-show');
                $('html').animate({
                scrollTop: list.offset().top - 150
                }, 500);
            }
        }
    },
    updated(){

    },
    mounted(){

    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH']),
        getSections(){
            let arItems = {};
            for(let i in this.struct[this.structKey].CHILDS){
                if(this.struct[this.structKey].CHILDS[i].componentData.VUE_COMPONENT == 'CatalogInnerSections'){
                    arItems = this.struct[this.structKey].CHILDS[i].componentData.ITEMS;
                }
            }
            return arItems;
        }
    },
    template: `
<div v-if="Object.keys(getSections).length" class="catalog__links-wp">
    <div class="catalog__links js-catalog-links-list">
        <a v-for="item in getSections" :href="item.LINK" class="catalog__links-item js-catalog-links-item">
            {{item.NAME}}
            <div class="catalog__links-item-amount">
                {{item.COUNT}} {{this.num_word(item.COUNT, ['модель', 'модели', 'моделей'])}}
            </div>
        </a>
    </div>

    <a v-if="Object.keys(getSections).length > 6" href="#" @click.prevent="showMore($event)" class="btn-showmore js-catalog-links-btn is-active">
        Показать ещё
    </a>

</div>
    `
}